import React, { useState } from "react";
import { useParams } from "react-router-dom";
import LoginForm from "../ui/LoginForm";
import RegisterForm from "../ui/RegisterForm";
import { useI18n } from "../i18n/LanguageContext";

const Login = () => {
  const { type } = useParams();
  const [formType, setFormType] = useState(
    type === "register" ? type : "login"
  );
  const { t } = useI18n();
  const toggleFormType = (params) => {
    setFormType((prevState) =>
      prevState === "register" ? "login" : "register"
    );
  };
  return (
    <div className="w-full overflow-x-hidden px-3 py-4 sm:py-8">
      <div className="flex justify-center">
        <div className="w-full max-w-md flex-col rounded-md bg-slate-100 p-3 shadow sm:p-4">
          <div key={formType} className="form-enter">
            {formType === "register" ? (
              <>
                <h3 className="mb-4 flex justify-center py-5 font-serif text-lg font-bold">
                  {t("register.title")}
                </h3>
                <RegisterForm />
                <div className="px-1 sm:px-5">
                  {t("login.haveAccount")}
                  <button
                    className="btn-smooth px-2 text-emerald-700 hover:text-emerald-500"
                    onClick={toggleFormType}
                    type="button"
                  >
                    {t("login.signIn")}
                  </button>
                </div>
              </>
            ) : (
              <>
                <h3 className="mb-4 flex justify-center font-serif text-lg font-bold">
                  {t("login.title")}
                </h3>
                <LoginForm />
                <div className="px-1 sm:px-5">
                  {t("login.noAccount")}
                  <button
                    className="btn-smooth px-2 text-emerald-700 hover:text-emerald-500"
                    onClick={toggleFormType}
                    type="button"
                  >
                    {t("login.signUp")}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
